import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ResumeViewer = ({ resume }) => {
  const handleDownload = () => {
    // Mock download functionality
    console.log('Downloading resume:', resume?.fileName);
  };

  const handleView = () => {
    // Mock view functionality
    console.log('Opening resume viewer:', resume?.fileName);
  };

  return (
    <div className="space-y-6">
      {/* Resume Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 p-4 bg-muted/50 rounded-lg">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
            <Icon name="FileText" size={20} className="text-red-600" />
          </div>
          <div>
            <h3 className="font-medium text-foreground">{resume?.fileName}</h3>
            <p className="text-sm text-muted-foreground">
              {resume?.fileSize} • Uploaded {resume?.uploadDate}
            </p>
          </div>
        </div>
        
        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            iconName="Eye"
            iconPosition="left"
            onClick={handleView}
          >
            View
          </Button>
          <Button
            variant="outline"
            size="sm"
            iconName="Download"
            iconPosition="left"
            onClick={handleDownload}
          >
            Download
          </Button>
        </div>
      </div>
      {/* Resume Preview */}
      <div className="border border-border rounded-lg overflow-hidden">
        <div className="bg-muted/30 p-4 border-b border-border">
          <h4 className="font-medium text-foreground">Resume Preview</h4>
          <p className="text-sm text-muted-foreground">Click "View" to open full document</p>
        </div>
        
        <div className="p-6 bg-white min-h-[600px] space-y-6">
          {/* Mock Resume Content */}
          <div className="text-center border-b border-gray-200 pb-6">
            <h2 className="text-2xl font-bold text-gray-900 mb-2">{resume?.candidateName}</h2>
            <p className="text-gray-600 mb-1">{resume?.title}</p>
            <p className="text-gray-500 text-sm">{resume?.contact}</p>
          </div>

          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Professional Summary</h3>
              <p className="text-gray-700 text-sm leading-relaxed">{resume?.summary}</p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Experience</h3>
              <div className="space-y-4">
                {resume?.experience?.map((exp, index) => (
                  <div key={index} className="border-l-2 border-gray-200 pl-4">
                    <h4 className="font-medium text-gray-900">{exp?.position}</h4>
                    <p className="text-gray-600 text-sm">{exp?.company} • {exp?.duration}</p>
                    <p className="text-gray-700 text-sm mt-1">{exp?.description}</p>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Skills</h3>
              <div className="flex flex-wrap gap-2">
                {resume?.skills?.map((skill, index) => (
                  <span
                    key={index}
                    className="px-3 py-1 bg-gray-100 text-gray-700 text-sm rounded-full"
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResumeViewer;